module.exports = __webpack_public_path__ + "assets/img/recordIcon2.8880c7e5.png";